import React from 'react';
import { colors } from './constants';
import { XIcon, ClipboardIcon } from './Icons';
import { DatePicker } from "rsuite";
import "rsuite/dist/rsuite-no-reset.min.css";
 import dayjs from "dayjs";
const AdmissionFormModal = ({ show, onClose, handleFormSubmit }) => {
const [formData, setFormData] = React.useState({
  patientName: "",
  age: "",
  gender: "",
  bloodGroup: "",
  contact: "",
  emergencyContact: "",
  doctor: "",
  admissionDate: "",
  medicalCondition: "",
  allergies: "",
  insuranceNumber: "",
  isDateInputFocused: false,
});
const handleFormChange = (e) => {
  const { name, value } = e.target;
  setFormData((prev) => ({ ...prev, [name]: value }));
};

  if (!show) return null;

  const styles = {
    modalOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      backdropFilter: 'blur(4px)'
    },
    modal: {
      background: colors.cream100,
      borderRadius: '12px',
      width: '90%',
      maxWidth: '600px',
      maxHeight: '85vh',
      overflow: 'auto',
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)'
    },
    modalHeader: {
      padding: '24px',
      borderBottom: `1px solid rgba(94, 82, 64, 0.12)`,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      position: 'sticky',
      top: 0,
      background: colors.cream100,
      zIndex: 1
    },
    modalTitle: {
      fontSize: '18px',
      fontWeight: 550,
      color: colors.slate900,
      margin: 0,
      display: 'flex',
      alignItems: 'center',
      gap: '12px'
    },
    closeButton: {
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      padding: '8px',
      display: 'flex',
      alignItems: 'center',
      color: colors.slate500,
      borderRadius: '6px',
      transition: 'all 0.2s ease'
    },
    modalBody: {
      padding: '24px'
    },
    formGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '16px'
    },
    formGroup: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px'
    },
    formGroupFull: {
      gridColumn: '1 / -1'
    },
    formLabel: {
      fontSize: '12px',
      fontWeight: 500,
      color: colors.slate900
    },
    formInput: {
      padding: '10px 12px',
      fontSize: '14px',
      fontFamily: 'inherit',
      border: `1px solid rgba(94, 82, 64, 0.2)`,
      borderRadius: '8px',
      background: colors.cream50,
      color: colors.slate900,
      transition: 'all 0.2s ease',
      outline: 'none'
    },
    formTextarea: {
      padding: '10px 12px',
      fontSize: '14px',
      fontFamily: 'inherit',
      border: `1px solid rgba(94, 82, 64, 0.2)`,
      borderRadius: '8px',
      background: colors.cream50,
      color: colors.slate900,
      transition: 'all 0.2s ease',
      outline: 'none',
      resize: 'vertical',
      minHeight: '80px'
    },
    modalFooter: {
      padding: '24px',
      borderTop: `1px solid rgba(94, 82, 64, 0.12)`,
      display: 'flex',
      gap: '12px',
      justifyContent: 'flex-end',
      position: 'sticky',
      bottom: 0,
      background: colors.cream100
    },
    btnPrimary: {
      padding: '12px 24px',
      fontSize: '14px',
      fontFamily: 'inherit',
      fontWeight: 500,
      borderRadius: '8px',
      border: 'none',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      background: colors.teal500,
      color: colors.cream50
    },
    btnSecondary: {
      padding: '12px 24px',
      fontSize: '14px',
      fontFamily: 'inherit',
      fontWeight: 500,
      borderRadius: '8px',
      border: `1px solid rgba(94, 82, 64, 0.2)`,
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      background: 'transparent',
      color: colors.slate900
    }
  };

  return (
    <div style={styles.modalOverlay} onClick={onClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div style={styles.modalHeader}>
          <h2 style={styles.modalTitle}>
            <ClipboardIcon />
            Patient Admission Form
          </h2>
          <button 
            style={styles.closeButton}
            onClick={onClose}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(94, 82, 64, 0.12)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'none';
            }}
          >
            <XIcon />
          </button>
        </div>

        <form onSubmit={handleFormSubmit}>
          <div style={styles.modalBody}>
            <div style={styles.formGrid}>
              <div style={styles.formGroup}>
                <label style={styles.formLabel}>Patient Name *</label>
                <input
                  type="text"
                  name="patientName"
                  style={styles.formInput}
                  value={formData.patientName}
                  onChange={handleFormChange}
                  required
                  onFocus={(e) => e.currentTarget.style.borderColor = colors.teal500}
                  onBlur={(e) => e.currentTarget.style.borderColor = 'rgba(94, 82, 64, 0.2)'}
                />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.formLabel}>Age *</label>
                <input
                  type="number"
                  name="age"
                  style={styles.formInput}
                  value={formData.age}
                  onChange={handleFormChange}
                  required
                  onFocus={(e) => e.currentTarget.style.borderColor = colors.teal500}
                  onBlur={(e) => e.currentTarget.style.borderColor = 'rgba(94, 82, 64, 0.2)'}
                />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.formLabel}>Gender *</label>
                <select
                  name="gender"
                  style={styles.formInput}
                  value={formData.gender}
                  onChange={handleFormChange}
                  required
                  onFocus={(e) => e.currentTarget.style.borderColor = colors.teal500}
                  onBlur={(e) => e.currentTarget.style.borderColor = 'rgba(94, 82, 64, 0.2)'}
                >
                  <option value="">Select Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </select>
              </div>

              <div style={styles.formGroup}>
                <label style={styles.formLabel}>Blood Group</label>
                <select
                  name="bloodGroup"
                  style={styles.formInput}
                  value={formData.bloodGroup}
                  onChange={handleFormChange}
                  onFocus={(e) => e.currentTarget.style.borderColor = colors.teal500}
                  onBlur={(e) => e.currentTarget.style.borderColor = 'rgba(94, 82, 64, 0.2)'}
                >
                  <option value="">Select Blood Group</option>
                  <option value="A+">A+</option>
                  <option value="A-">A-</option>
                  <option value="B+">B+</option>
                  <option value="B-">B-</option>
                  <option value="AB+">AB+</option>
                  <option value="AB-">AB-</option>
                  <option value="O+">O+</option>
                  <option value="O-">O-</option>
                </select>
              </div>

              <div style={styles.formGroup}>
                <label style={styles.formLabel}>Contact Number *</label>
                <input
                  type="tel"
                  name="contact"
                  style={styles.formInput}
                  value={formData.contact}
                  onChange={handleFormChange}
                  required
                  onFocus={(e) => e.currentTarget.style.borderColor = colors.teal500}
                  onBlur={(e) => e.currentTarget.style.borderColor = 'rgba(94, 82, 64, 0.2)'}
                />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.formLabel}>Emergency Contact</label>
                <input
                  type="tel"
                  name="emergencyContact"
                  style={styles.formInput}
                  value={formData.emergencyContact}
                  onChange={handleFormChange}
                  onFocus={(e) => e.currentTarget.style.borderColor = colors.teal500}
                  onBlur={(e) => e.currentTarget.style.borderColor = 'rgba(94, 82, 64, 0.2)'}
                />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.formLabel}>Attending Doctor *</label>
                <input
                  type="text"
                  name="doctor"
                  style={styles.formInput}
                  value={formData.doctor}
                  onChange={handleFormChange}
                  required
                  onFocus={(e) => e.currentTarget.style.borderColor = colors.teal500}
                  onBlur={(e) => e.currentTarget.style.borderColor = 'rgba(94, 82, 64, 0.2)'}
                />
              </div>

      


              <div style={styles.formGroup}>
                <label style={styles.formLabel}>Admission Date *</label>
                <DatePicker
                  oneTap
                  name="admissionDate"
                  value={
                    formData.admissionDate 
                      ? new Date(formData.admissionDate) 
                      : null
                  } 
                  onChange={(value) =>
                    handleFormChange({
                      target: {
                        name: "admissionDate",
                        value: value ? dayjs(value).format("YYYY-MM-DD") : "",
                      },
                    })
                  }
                  format="dd-MMM-yyyy"
                  placeholder="DD-MMM-YYYY"
                
                  appearance="default"
                  cleanable={false}
                />
              </div>
              <div style={{ ...styles.formGroup, ...styles.formGroupFull }}>
                <label style={styles.formLabel}>Medical Condition *</label>
                <input
                  type="text"
                  name="medicalCondition"
                  style={styles.formInput}
                  value={formData.medicalCondition}
                  onChange={handleFormChange}
                  required
                  onFocus={(e) => e.currentTarget.style.borderColor = colors.teal500}
                  onBlur={(e) => e.currentTarget.style.borderColor = 'rgba(94, 82, 64, 0.2)'}
                />
              </div>

              <div style={{ ...styles.formGroup, ...styles.formGroupFull }}>
                <label style={styles.formLabel}>Allergies</label>
                <textarea
                  name="allergies"
                  style={styles.formTextarea}
                  value={formData.allergies}
                  onChange={handleFormChange}
                  placeholder="List any known allergies..."
                  onFocus={(e) => e.currentTarget.style.borderColor = colors.teal500}
                  onBlur={(e) => e.currentTarget.style.borderColor = 'rgba(94, 82, 64, 0.2)'}
                />
              </div>

              <div style={{ ...styles.formGroup, ...styles.formGroupFull }}>
                <label style={styles.formLabel}>Insurance Number</label>
                <input
                  type="text"
                  name="insuranceNumber"
                  style={styles.formInput}
                  value={formData.insuranceNumber}
                  onChange={handleFormChange}
                  onFocus={(e) => e.currentTarget.style.borderColor = colors.teal500}
                  onBlur={(e) => e.currentTarget.style.borderColor = 'rgba(94, 82, 64, 0.2)'}
                />
              </div>
            </div>
          </div>

          <div style={styles.modalFooter}>
            <button 
              type="button" 
              style={styles.btnSecondary}
              onClick={onClose}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'rgba(94, 82, 64, 0.08)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'transparent';
              }}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              style={styles.btnPrimary}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = colors.teal600;
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(33, 128, 141, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = colors.teal500;
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              Admit Patient
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdmissionFormModal;
